import { Button } from "waapi/waap-ui/components/Button/Button.js";
import { DocumentCopyBold } from "waapi/waap-ui/components/Iconsax/DocumentCopyBold.js";
import { Tooltip } from "waapi/waap-ui/components/Tooltip/Tooltip.component.js";
import { useCopyToClipboard } from "../../../customHooks/useCopyToClipboard.js";
import { useTranslation } from "../../../customHooks/useTranslation/index.js";
import { CopyMyAffiliationCodeProps } from "./types.js";

export const CopyMyAffiliationCode = ({ affiliationCode }: CopyMyAffiliationCodeProps) => {
    const { t, translations } = useTranslation();
    const { copyToClipboard } = useCopyToClipboard();

    const copyDefaultLink = () => {
        copyToClipboard({
            textToCopy: affiliationCode,
            textFailed: t(translations.header.shareTracking.failed()),
            textSuccess: t(translations.header.shareTracking.success()),
        });
    };

    return (
        <Tooltip containerStyle={{ textAlign: "center" }} content={t(translations.header.shareTracking.tooltip())}>
            <Button iconLeft={DocumentCopyBold} size="small" variant="outline" color="primary" onClick={copyDefaultLink}>
                {affiliationCode}
            </Button>
        </Tooltip>
    );
};
